<header id="myHeader">
    <div class="space-between">
        <div class="left-menu d-flex">
            <div class="haederlogo">
                <a routerLink="/">
                    <img alt="Logo" src="./assets/media/logos/{{ IA }}" style="height: 60px" />
                </a>
            </div>

            <ng-container>
                <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                    <ng-container>
                        <div #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile" [ngClass]="headerMenuCSSClasses">
                            <ul class="menu-nav" [ngClass]="ulCSSClasses">
                                <li class="menu-item menu-item-rel">
                                    <a class="menu-link menu-padding" [routerLink]="['/landing']">
                                        <span class="menu-text"><i class="fas fa-home"></i>{{ 'LANDING_PAGE.BUTTONS_TEXT.HOME' | transloco }}</span>
                                    </a>
                                </li>

                                <li class="menu-item menu-item-rel">
                                    <div class="menu_class">
                                        <a class="menu-link menu-padding" [routerLink]="['/landing/pricing']" [routerLinkActive]="'link-active'">
                                            {{ 'LANDING_PAGE.BUTTONS_TEXT.PRICING_DETAILS' | transloco }}
                                        </a>
                                    </div>
                                </li>

                                <li class="menu-item menu-item-rel">
                                    <div class="menu_class">
                                        <a class="menu-link menu-padding" [routerLink]="['/landing/contactUs']" [routerLinkActive]="'link-active'">
                                            {{ 'LANDING_PAGE.BUTTONS_TEXT.CONTACT_US' | transloco }}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="right-menu" data-placement="left" placement="bottom-right">
            <div class="position-relative" style="top: 10px">
                <a class="btn signin-ebtn" (click)="user()"
                    ><span style="font-weight: bold; position: relative; top: 3px">{{ 'LANDING_PAGE.BUTTONS_TEXT.SIGNIN' | transloco }}</span
                    >&nbsp;<span><i class="fas fa-user user_toggle"></i></span
                ></a>
                <!--<i class="fa fa-user-circle user_toggle" aria-hidden="true" (click)="user()"></i>-->
                <div class="navabr_dropdownTwo240" *ngIf="isUserDropdown">
                    <div class="navbar_dropdownTwoHead">
                        <a href="javascript:void(0)" class="UserProfileLinks__ProfileLink font-weight-bold" (click)="login()">{{
                            'LANDING_PAGE.BUTTONS_TEXT.LOGIN' | transloco
                        }}</a>
                    </div>
                    <div class="navbar_dropdownTwoHead">
                        <a href="javascript:void(0)" class="UserProfileLinks__ProfileLink font-weight-bold" (click)="Signup()">{{
                            'LANDING_PAGE.BUTTONS_TEXT.SIGN_UP_FREE' | transloco
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<!--test commit-->
